(function () {
  const KEEP_KEYWORDS = [''];

  function transformTitle(title) {
    let prefix = '';

    const beforeBracket = title.includes('】')
      ? title.split('】')[0]
      : '';

    KEEP_KEYWORDS.forEach(kw => {
      if (beforeBracket.includes(kw)) {
        prefix += kw + ' ';
      }
    });

    const afterBracket = title.includes('】')
      ? title.split('】').slice(1).join('】').trim()
      : title.trim();

    // 【】と（）と()の中身ごと削除
    const cleaned = (prefix + afterBracket)
      .trim()
      .replace(/（[^）]*）/g, '')  // 全角カッコ
      .replace(/\([^)]*\)/g, '')   // 半角カッコ
      .trim();

    return cleaned;
  }

  function applyTransform() {
    document.querySelectorAll('.product-card__title .reversed-link__text').forEach(el => {
      if (el.dataset.titleTransformed) return;
      el.dataset.titleTransformed = 'true';
      el.textContent = transformTitle(el.textContent);
    });
  }

  applyTransform();

  const observer = new MutationObserver(() => applyTransform());
  observer.observe(document.body, { childList: true, subtree: true });
})();
